import { useTranslation } from "react-i18next";
import "./pvsTips.scss";

const SPEC = ["name", "satzart", "folder", "fileName", "returnFolder"] as const;

/** Which practice software is tested, and the values needed to set up the GDT device — by the practice
 *  itself or its software vendor. No per-vendor menu paths, just the values (with per-vendor examples
 *  where they differ, e.g. the file name). A value may hold several lines ("\n"). */
export function PvsTips() {
    const { t } = useTranslation();

    return (
        <div className="pvs-tips">
            <p className="pvs-tips__tested">{t("syncGuide.pvs.tested")}</p>

            <div className="pvs-tips__spec">
                <p className="pvs-tips__spec-title">{t("syncGuide.pvs.specTitle")}</p>
                <dl className="pvs-tips__spec-list">
                    {SPEC.map((s) => (
                        <div key={s} className="pvs-tips__spec-row">
                            <dt>{t(`syncGuide.pvs.spec.${s}.label`)}</dt>
                            <dd>
                                <span className="pvs-tips__value">{t(`syncGuide.pvs.spec.${s}.value`)}</span>
                                <span className="pvs-tips__hint">{t(`syncGuide.pvs.spec.${s}.hint`)}</span>
                            </dd>
                        </div>
                    ))}
                </dl>
            </div>
        </div>
    );
}
